angular.module("dx.webapp.skolon", [
	"dx.webapp.api",
]);
